<template>
  <div class="auth-wrapper auth-v1 px-4">
    <div
      v-if="loading"
      class="loading"
    >
      Loading
    </div>
    <div class="auth-inner py-4">

      <!-- Login v1 -->
      <b-card class="mb-0">
        <span class="brand-logo mb-2">
          <img
            :src="appLogoImageLg"
            alt="logo"
            style="width: 30%;"
          >
        </span>
        <b-link class="brand-logo mb-1">
          <h2 class="brand-text ml-1">
            Connect with MLF
          </h2>
          <!-- <h2 class="brand-text ml-1">
            Connect with MLF {{ appName }}
          </h2> -->
        </b-link>

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="login"
          >
            <!-- email -->
            <b-form-group
              label="Email"
              label-for="login-email"
            >
              <b-form-input
                id="login-email"
                v-model="userEmail"
                :state="null"
                name="login-email"
                placeholder="john@example.com"
              />
              <!-- <validation-provider
                #default="{ errors }"
                name="Email"
                vid="email"
                rules="required|email"
              >
                <b-form-input
                  id="login-email"
                  v-model="userEmail"
                  :state="errors.length > 0 ? false:null"
                  name="login-email"
                  placeholder="john@example.com"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider> -->
            </b-form-group>

            <!-- forgot password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="login-password">Password</label>
                <!-- <b-link :to="{name:'auth-forgot-password'}">
                  <small>Forgot Password?</small>
                </b-link> -->
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                vid="password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="login-password"
                    v-model="password"
                    :state="errors.length > 0 ? false:null"
                    class="form-control-merge"
                    :type="passwordFieldType"
                    name="login-password"
                    placeholder="Password"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit buttons -->
            <b-button
              class="mt-3"
              type="submit"
              variant="primary"
              block
              :disabled="invalid"
            >
              Sign in
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BForm, BButton, VBTooltip,
} from 'bootstrap-vue'
// import { BCard, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BForm, BButton, VBTooltip } from 'bootstrap-vue'
// import { BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BInputGroup, BInputGroupAppend } from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { $themeConfig } from '@themeConfig'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BForm,
    BCard,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: '',
      password: '',
      status: '',
      // validation rules
      required,
      loading: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  setup() {
    // App Name
    const { appName, appLogoImageLg, appFEURL } = $themeConfig.app
    return {
      appName,
      appLogoImageLg,
      appFEURL,
    }
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          this.loading = true
          useJwt.login({
            email: this.userEmail,
            password: this.password,
          }).then(response => {
            /* eslint-disable no-console */
            // console.log(response)
            // localStorage.setItem('userData', JSON.stringify(response.data.userData))
            // this.$ability.update(response.data.userData.ability)
            // this.$router.replace(getHomeRouteForLoggedInUser('admin'))
            // this.loading = false
            if (response.status === 200) {
              console.log('Response Status = 200')
              localStorage.setItem('userData', JSON.stringify(response.data.userData))
              this.$ability.update(response.data.userData.ability)
              this.$router.replace(getHomeRouteForLoggedInUser('admin'))
              this.loading = false
            }
          }).catch(error => {
            this.$refs.loginForm.setErrors(error.response.data.error)
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
